export default __webpack_public_path__ + "static/media/plantillaClientes.a5c9c946.xlsx";